module.exports = __webpack_public_path__ + "static/media/3DPPA11.7d4187fa.jpg";